export default __webpack_public_path__ + "static/media/V375_E_BD.8964a051.pdf";